import React, {useState, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import queryString from 'query-string'
import {getValidateDealSession} from '../../services/outReach'
import Loader from '../../components/Loader'
import {Redirect} from 'react-router-dom'
import {useSettings} from '../../utils/Settings'
import {useStickyState} from '../../utils/customHooks'
import {GlobalSetting} from '../../utils/constants'

const OutReach = props => {
    const [dealLoader, setdealLoader] = useState()
    const [redirectlogin, setRedirectlogin] = useState(false)
    const [error, setError] = useState()
    const {login} = useSettings()
    const {unit} = useParams()

    const [clientObject, setClientObject] = useStickyState(
        GlobalSetting.entityObject,
        'clientObject'
    )

    useEffect(() => {
        const queryParam = queryString.parse(props.location.search)
        if (
            (queryParam.deal === undefined || queryParam.deal === null) &&
            (queryParam.refresh === undefined || queryParam.refresh === null) &&
            (queryParam.continuetoken === undefined ||
                queryParam.continuetoken === null) &&
            (queryParam.pt === undefined || queryParam.pt === null)
        )
            setRedirectlogin(true)

        const callAPI = async () => {
            setdealLoader(true)
            let input = {}
            if (queryParam.continuetoken)
                input = {continuetoken: queryParam.continuetoken}
            else if (queryParam.refresh) {
                input = {refresh: queryParam.refresh}
            } else if (queryParam.pt) {
                input = {pt: queryParam.pt}
            } else {
                input = {deal: queryParam.deal}
            }

            const result = await getValidateDealSession(input)
            if (queryParam['client-entity-id']) {
                const key = sessionStorage.getItem('sessionClientEntityId')
                if (queryParam['client-entity-id']) {
                    sessionStorage.setItem(
                        'sessionClientEntityId',
                        String(queryParam['client-entity-id'])
                    )
                }
                if (queryParam['parent-client-entity-id'])
                    sessionStorage.setItem(
                        'sessionParentClientEntityId',
                        String(queryParam['parent-client-entity-id'])
                    )
            }
            if (queryParam['open-on-section'])
                sessionStorage.setItem(
                    'openOnSection',
                    String(queryParam['open-on-section'])
                )
            if (unit) sessionStorage.setItem('unit', String(unit))
            if (queryParam['pt']) {
                sessionStorage.setItem('milestone', String(false))
            }
            if (queryParam['defaultpid']) {
                setClientObject({
                    ...clientObject,
                    practiceid: parseInt(queryParam['defaultpid']) || '',
                })
            }
            if (result.success.route) login()

            if (result.error.message) {
                setdealLoader(false)
                setError(result.error.message)
            }
        }
        callAPI()
    }, [])

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'

    if (redirectlogin) return <Redirect to={{pathname: loginPath}} />
    if (dealLoader)
        return (
            <React.Fragment>
                <Loader type="page" />
            </React.Fragment>
        )
    if (error) return <div>{error}</div>

    return <div>Unauthorized: Access to this resource is denied</div>
}

export default OutReach
